import { useLocation } from "react-router";
import { useGetData } from "..";
import { ENDPOINTS } from "../../constants/endpoints";

function useTrackCargoLogic() {
  const search = useLocation().search;
  const order = new URLSearchParams(search).get("order");

  return {};
}

export default useTrackCargoLogic;
